import { useState, useEffect } from 'react';
import { throttleToAnimationFrame } from '@utils/common';

function useElementHeight({
  elementRef
}) {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const flooredHeight = elementRef.current?.clientHeight;

      // To avoid scroolbars we must always ensure that the height is ceiled and
      // not floored, since being just one pixel too short could potentially
      // trigger scrollbars.
      //
      // NB: I know that this will potentially calculate one pixel too high, but
      // that does not matter that much. 100px vs. 101px is barely  noticeable
      setHeight(flooredHeight ? flooredHeight + 1 : 0);
    };
    updateHeight();
    const throttled = throttleToAnimationFrame(updateHeight);
    window.addEventListener("resize", throttled);
    window.addEventListener("orientationchange", throttled);
    return () => {
      window.removeEventListener("resize", throttled);
      window.removeEventListener("orientationchange", throttled);
    };
  }, [elementRef]);
  return height;
}

export { useElementHeight };
//# sourceMappingURL=useElementHeight.js.map
